import PriceSettingsApi, {MarkupData, prices} from "../../../api/PriceSettingsApi"
import {makeAutoObservable} from "mobx"
import React from "react"
import {Select} from "../../../lib/wa-2.0"
import priceUpdateController from "../../pageControllers/PriceUpdateController"
import ReactTooltip from "react-tooltip"


export default class MarkUp {
    private _shop_category_id: number
    private _type: prices
    private _hasChildren: boolean

    constructor(markup: MarkupData, hasChildren: boolean) {
        this._shop_category_id = +markup.shop_category_id
        this._type = markup.type
        this._unit = markup.unit
        this._value = +markup.value
        this._hasChildren = hasChildren
        makeAutoObservable(this)
    }

    private _unit: string

    get unit(): string {
        return this._unit
    }

    set unit(value: string) {
        this._unit = value
        this.saveMarkup()
    }

    private _value: number

    get value(): number {
        return this._value
    }

    set value(value: number) {
        this._value = value
        this.saveMarkup()
    }

    get controller() {
        return <div className={"custom-px-16 custom-py-12 nowrap flexbox middle"} style={{width: "21%"}}>
            <input className={"smaller"} type={"number"} value={this.value}
                   onChange={event => this.value = +event.target.value} style={{width: "60px"}}/>
            <Select
                className={"smaller"}
                value={priceUpdateController.getOptionByUnit(this.unit).value}
                onChange={(e: { target: { value: string } }) => this.unit = e.target.value}
                options={priceUpdateController.units}
                style={{width: "60px"}}
            />
            <div className={"width-10"}>
                {this._hasChildren && <React.Fragment>
                    <span
                        className={"include-children-btn"}
                        onClick={() => this.saveMarkup(true)}
                        data-tip={true}
                        data-for={this._shop_category_id + this._type}
                    />
                    <ReactTooltip
                        id={this._shop_category_id + this._type}
                        effect="solid"
                    >
                        Применить к подкатегориям
                    </ReactTooltip>
                </React.Fragment>}
            </div>
            {/*<Checkbox checked={this.include_children}*/}
            {/*       onChange={(event: { target: { checked: boolean } }) => this.include_children = event.target.checked}/>*/}
        </div>
    }

    private saveMarkup(includeChild = false) {
        PriceSettingsApi.saveMarkupData({
            include_children: includeChild,
            shop_category_id: this._shop_category_id.toString(),
            type: this._type,
            value: this._value.toString(),
            unit: this._unit
        }).then((response) => {
            if (includeChild) {
                priceUpdateController.loadSettings()
            }
        })
    }

    private deleteMarkup() {
        this._value = 0
        PriceSettingsApi.deleteMarkupData({shop_category_id: this._shop_category_id.toString(), type: this._type})
    }
}